import { AuthorContent } from '@silvertours/back-domain-page';
import {
  WrapperSmall,
  ImageWrapperSmall,
  StyledImageSmall,
  StyledLink,
  AuthorTextSmall,
} from './Author.styles';

type AuthorInTitleProps = AuthorContent & {
  textBefore: string;
  textAfter: string;
};

const AuthorInTitle = ({
  name,
  image,
  textBefore,
  textAfter,
}: AuthorInTitleProps) => (
  <WrapperSmall>
    <ImageWrapperSmall>
      {image && (
        <StyledImageSmall src={image.src} alt="" width="40" height="40" />
      )}
    </ImageWrapperSmall>
    <AuthorTextSmall>
      {textBefore}&nbsp;
      <StyledLink href="#author">{name}</StyledLink> {textAfter}
    </AuthorTextSmall>
  </WrapperSmall>
);
export { AuthorInTitle };
